// extracted by mini-css-extract-plugin
export default {"search_bar":"Personagens_search_bar__FcY1z","search":"Personagens_search__iL7HM","icon":"Personagens_icon__aWDkC","content":"Personagens_content__uoeOD"};